/** @file tiltOf: the body tilt quaternion of the pose parameters, or null when there is none (21.9). */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import { quatFromYawPitchRoll } from '@zilo/pose3d-math/quat/quatFromYawPitchRoll';
import type { PoseParams } from '@zilo/pose3d-pose/contract';

/**
 * Design 21.9: `params.tilt` (body space) when given, else the shorthand `Q(0, pitchDeg, rollDeg)`; null when neither
 * is set (or both shorthand angles are 0), so an untilted pose is computed exactly as without the tilt step.
 */
export function tiltOf(params: PoseParams): Quat | null {
  if (params.tilt !== undefined) return params.tilt;
  const pitch = params.pitchDeg ?? 0;
  const roll = params.rollDeg ?? 0;
  return pitch === 0 && roll === 0 ? null : quatFromYawPitchRoll(0, pitch, roll);
}
